import { CategoriesSliceState } from 'src/store/reducers/categories/types';

export const createInitialCategoriesState = (): CategoriesSliceState => ({
  categories: []
});
